import { PkDivider } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import CompetitionIdentifier from './CompetitionIdentifier';

import { useWindowSize } from '@hooks/useWindowSize';
import type { MenuItem } from '@shared-types/menu.types';

import * as styles from './styles.module.scss';

const UefaCompetitions = ({ item }: { item: MenuItem }) => {
  const { isMobile } = useWindowSize();

  return (
    <div className='pk-d--flex pk-flex--column pk-gap--l pk-w--100'>
      <div className='pk-text--text-01 pk-font-size--xl pk-font-size-md--xl2 pk-font--base-semibold'>{item.text}</div>
      {item.menuItems.map((m, i) => (
        <div key={m.id} className='pk-d--flex pk-flex--column pk-gap--l'>
          <div className='pk-text--text-01 pk-font-size--l pk-font-size-md--xl pk-font--base-semibold'>{m.text}</div>
          <div className={clsx('pk-w--100 pk-gap--xs2 pk-row-gap--l pk-gap-md--l', styles.compGrid)}>
            {m.menuItems.map((mi) => (
              <CompetitionIdentifier key={mi.id} item={mi} />
            ))}
          </div>
          {isMobile && i < item.menuItems.length - 1 && <PkDivider className='pk-m--0' />}
        </div>
      ))}
      <div className='pk-py--l'>&nbsp;</div>
    </div>
  );
};

export default memo(UefaCompetitions);
